import { SpaceBetween, StatusIndicator, TextContent } from '@amzn/awsui-components-react'
import { ITEM_TYPES } from '../../../Constant'
import StatusInfoPopover from '../../reusable/StatusInfoPopover'
import { isNumber } from '../../../common/Util'

const DEFAULT_SIZE_OF_PANEL_IN_PIXEL = 250
const SIZE_OF_EACH_TEAM_PANEL_IN_PIXEL = 50

export const getSplitPanelSize = (selectedGroups) => {
    return (
        selectedGroups[0].number_of_teams * SIZE_OF_EACH_TEAM_PANEL_IN_PIXEL +
        DEFAULT_SIZE_OF_PANEL_IN_PIXEL
    )
}

export const getExpectedTotal = (expected_sum) => {
    if (isNumber(expected_sum)) return expected_sum
    if (isNumber(expected_sum?.employee) && isNumber(expected_sum?.other))
        return Number(expected_sum.employee) + Number(expected_sum.other)
    return undefined
}

export const VarianceComponent = ({ value }) => {
    if (!isNumber(value)) return <StatusIndicator type='stopped'>N/A</StatusIndicator>

    const diff = Math.abs(+value)
    return <StatusIndicator type={diff === 0 ? 'success' : 'warning'}>{diff}</StatusIndicator>
}

export const ControlExpectedComponent = ({ control, expected, showDiff = false }) => {
    const expected_total = getExpectedTotal(expected)
    if (!isNumber(control) || !isNumber(expected_total)) return <TextContent>N/A</TextContent>

    return (
        <SpaceBetween size='m' direction='horizontal'>
            <div style={{ minWidth: '70px' }}> {`${control} / ${expected_total}`} </div>
            {showDiff && <VarianceComponent value={control - expected_total} />}
        </SpaceBetween>
    )
}

export const getGroupControlColumns = (entityType: ITEM_TYPES) => [
    {
        id: 'control_expected_group_sum',
        header: (
            <StatusInfoPopover
                title='Control / Group'
                popoverContent={`The ${entityType}'s control headcount over the sum of control headcount from all groups within the ${entityType}.`}
            />
        ),
        cell: (e) => (
            <ControlExpectedComponent
                control={e.control_headcount_sum}
                expected={e.expected_group_sum}
            />
        ),
    },
    {
        id: 'variance_group',
        header: (
            <StatusInfoPopover
                title='Group Variance'
                popoverContent={`The ${entityType}'s control headcount - sum of control headcount from all groups within the ${entityType}.`}
            />
        ),
        cell: (e) => <VarianceComponent value={e.variance_group} />,
        sortingField: 'variance_group',
    },
]

export const getTeamControlColumns = (entityType: ITEM_TYPES) => [
    {
        id: 'control_expected_team_sum',
        header: (
            <StatusInfoPopover
                title='Control / Team'
                popoverContent={`The ${entityType}'s control headcount over the sum of control headcount from all teams within the ${entityType}.`}
            />
        ),
        cell: (e) => (
            <ControlExpectedComponent
                control={e.control_headcount_sum}
                expected={e.expected_team_sum}
            />
        ),
    },
    {
        id: 'variance_team',
        header: (
            <StatusInfoPopover
                title='Team Variance'
                popoverContent={`The ${entityType}'s control member count - sum of control headcount from all teams within the ${entityType}.`}
            />
        ),
        cell: (e) => <VarianceComponent value={e.variance_team} />,
        sortingField: 'variance_team',
    },
]
